import React from 'react';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { useTranslation } from 'react-i18next';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react';

const styles = {
  root: {
    backgroundColor: '#0078d4',
  },
};

const NavBar = ({
  onLoginClick,
  isLoggedIn,
  displayName,
  onLogoutClick,
  isAuthorizing,
}) => {
  const { t: translator } = useTranslation();
  const text = translator('general.login');

  if (isAuthorizing) {
    return <Spinner size={SpinnerSize.large} />;
  }

  return isLoggedIn ? (
    <CommandBar
      styles={styles}
      farItems={getItems(displayName, onLogoutClick, isLoggedIn)}
    />
  ) : (
    <CommandBar styles={styles} farItems={getItems(text, onLoginClick)} />
  );
};

// Styling for login/logout.
var buttonStyles = {
  textContainer: {
    color: 'white',
  },
  root: {
    backgroundColor: '#0078d4',
    fontSize: '16px',
    selectors: {
      '.ms-Button-menuIcon': {
        color: 'white',
      },
    },
  },
  rootHovered: {
    backgroundColor: '#2b88d8',
  },
};

var getItems = (titles, onClick, isLoggedIn) => {
  if (isLoggedIn) {
    return [
      {
        key: 'Logout',
        name: titles,
        ariaLabel: 'Log ud',
        buttonStyles: buttonStyles,
        subMenuProps: {
          items: [
            {
              key: 'logOutButton',
              name: 'Log ud',
              iconProps: {
                iconName: 'Leave',
              },
              onClick: onClick,
            },
          ],
        },
      },
    ];
  } else {
    return [
      {
        key: 'Login',
        name: titles,
        cacheKey: 'myCacheKey', // changing this key will invalidate this items cache
        ariaLabel: 'Log in',
        onClick: onClick,
        buttonStyles: buttonStyles,
      },
    ];
  }
};

export { NavBar };
